import React from 'react'
import 'react-awesome-slider/dist/styles.css';
import { connect } from 'react-redux';
import * as Router from 'router';
import { Steps } from './constants';

export interface StepSelectionProps {
  completedSteps: number,
  push: any,
}
export const StepSelectionComponent = (props: StepSelectionProps) =>
	<div className="step-selection">
    {Steps.map((step, index) => {
      return <div key={index} className={`step ${props.completedSteps >= (index + 1) ? 'completed' : '' }`}
        onClick={() => props.push(step.path)}>
      <div className="v-stepper">
        <div className="circle"><div className="inner-circle"></div></div>
        <div className="line"></div>
      </div>
      <div className="content">
        <div className="title">{step.title}</div>
        <div className="description">{step.description}</div>
      </div>
    </div>
    })}
	</div>

export const StepSelection = connect(
  null,
  {
    push: Router.push,
  },
)(StepSelectionComponent)
